export default __webpack_public_path__ + "static/media/frenchfries.4f51c198.woff";